import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "100%",
      rows: {
        row1: [
          {
            name: "searchTerm",
            label: "Name",
            component: "text-field",
            width: "50%",
            sx: {
              ml: 1,
            },
            placeholder: "Select Name",
          },
          {
            name: "aliseName",
            label: "Alias",
            component: "text-field",
            width: "40%",
            gap: false,
            placeholder: "Select Alias",
          },
          {
            name: "Advanced Filters",
            label: "Advanced Filters",
            component: "outlinebutton",
            iconName: "LuSlidersVertical",
            width: "20%",
            action: "toggleAdvanced",
            sx: {
              mt: 4,
              mr: 2,
              flexGrow: 1,
              backgroundColor: "var(--gray-0)",
              borderColor: "var(--brand-600)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "fit-content",
              maxWidth: "100%",
              padding: "0 12px",
              "& .MuiButton-label": {
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
                overflow: "hidden",
              },
              "& .MuiButton-startIcon": {
                margin: 0,
                flexShrink: 0,
              },
            },
          },
        ],
        row2: [
          {
            name: "show",
            label: "Show",
            component: "dropdown",
            width: "30%",
            endIconName: "LuChevronDown",
          },
          {
            name: "customerStatus",
            label: "ApprovalStatus",
            component: "dropdown",
            width: "30%",
            endIconName: "LuChevronDown",
          },
          {
            name: "countryNames",
            label: "Country",
            component: "text-field",
            width: "25%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCountry",
            placeholder: "Select Country",
          },
          {
            name: "userTypeIds",
            label: "Entity Types",
            component: "multiselect",
            placeholder: "Select Entity Types",
            width: "30%",
            type:"autocomplete",
            endpoint:"getCustomerType",
            options: []     // FIXED
          }
        ],

        row3: [
          {
            name: "line",
            component: "hr",
          },
        ],
        row4: [
          {
            name: "Clear",
            component: "outlinebutton",
            label: "Clear",
            action: "closeAdvanced",
            width: "10%",
            sx: {
              display: "flex",
              justifyContent: "center", // right align
              ml: "auto", // alternative way
            },
          },
          {
            name: "search",
            component: "blackbutton",
            label: "Search",
            action: "search",
            
          },
        ],
      },
    },
  ],
};
